var render = function () {
  var _vm$items, _vm$items2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row mt-2 px-3"
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Sales - Gramedia Digital'
      }],
      "title": "All Sales - Gramedia Digital"
    }
  }), _c('div', {
    staticClass: "bg-white w-full rounded-xl p-4"
  }, [_c('div', {
    staticClass: "flex flex-row justify-start items-end mb-4"
  }, [_c('div', {
    staticClass: "w-full flex flex-row justify-between items-end"
  }, [_c('div', {
    staticClass: "flex flex-col pr-0"
  }, [_c('label', {
    staticClass: "text-gray-600 font-semibold mb-2"
  }, [_vm._v("Invoice")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "w-full border border-gray-300 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "type": "text",
      "placeholder": "Type Invoice No.",
      "onfocus": "this.placeholder = 'type invoice number...'"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, function ($event) {
        return _vm.actionGetReportInvoice();
      }]
    }
  })]), _c('div', {
    staticClass: "flex flex-col pr-0"
  }, [_c('label', {
    staticClass: "text-gray-600 font-semibold mb-2"
  }, [_vm._v("Period Date")]), _c('PeriodPicker', {
    on: {
      "range-selected": _vm.onRangeSelected,
      "month-selected": _vm.onMonthSelected,
      "clear": _vm.onClear
    }
  })], 1), _c('div', {
    staticClass: "flex flex-col w-64 pr-0"
  }, [_c('label', {
    staticClass: "text-gray-600 font-semibold mb-2"
  }, [_vm._v("Offer Type")]), _c('TypeDropdown', {
    staticClass: "w-32",
    attrs: {
      "options": _vm.offerTypeOptions,
      "defaultText": 'Select Offer Type'
    },
    model: {
      value: _vm.offerType,
      callback: function ($$v) {
        _vm.offerType = $$v;
      },
      expression: "offerType"
    }
  })], 1), _c('div', {
    staticClass: "flex flex-col pr-3 w-1/3"
  }, [_c('label', {
    staticClass: "text-gray-600 font-semibold mb-2"
  }, [_vm._v("Publisher (Optional)")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "disabled": _vm.userData.role_id === 5,
      "placeholder": "Type Publisher",
      "open-direction": "bottom",
      "options": _vm.publisherSearchOptions,
      "loading": _vm.isPublisherSearch,
      "multiple": true,
      "searchable": true,
      "close-on-select": false
    },
    on: {
      "search-change": _vm.publisherFind
    },
    model: {
      value: _vm.publisher,
      callback: function ($$v) {
        _vm.publisher = $$v;
      },
      expression: "publisher"
    }
  })], 1), _c('button', {
    staticClass: "bg-blue-700 text-white px-4 rounded-lg py-2.5 w-auto",
    on: {
      "click": _vm.onFilter
    }
  }, [_vm._v(" Filter ")])])]), (_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length ? _c('div', [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.items,
      "row-key": ['vendor_name', 'number_invoice', 'disbursement_period', 'offer_type'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": 50
    },
    scopedSlots: _vm._u([{
      key: "disbursement_period",
      fn: function (_ref) {
        var value = _ref.value;
        return [_vm._v(" " + _vm._s(_vm.formatPeriod(value)) + " ")];
      }
    }, {
      key: "header-disbursement-period",
      fn: function (_ref2) {
        var column = _ref2.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "offer_type",
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('span', {
          staticClass: "px-2 py-1 rounded-lg text-xs font-medium capitalize",
          class: _vm.offerTypeColor(value)
        }, [_vm._v(" " + _vm._s(value) + " ")])];
      }
    }, {
      key: "actions",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_vm.userData.role_id === 1 || _vm.userData.role_id === 14 || _vm.userData.role_id === 5 // && isPeriodAllowed(row.disbursement_period)
        ? _c('div', [row.alloweddownload ? _c('b-button', {
          attrs: {
            "id": ("invoice-download-" + (row.number_invoice)),
            "variant": row.is_active ? 'outline-primary' : 'outline-danger',
            "disabled": _vm.isButtonDisabled(row)
          },
          on: {
            "click": function ($event) {
              return _vm.downloadInvoice({
                offer_type: row.offer_type,
                vendor_id: row.vendor_id,
                period: row.disbursement_period,
                number_invoice: row.number_invoice
              });
            }
          }
        }, [row.is_active && !_vm.isLoadingBtn(row) && !_vm.isDownloaded(row) ? [_c('i', {
          staticClass: "fa fa-download"
        }), _vm._v(" Download ")] : !row.is_active ? [_c('i', {
          staticClass: "fa fa-ban"
        }), _vm._v(" Unavailable ")] : _vm.isLoadingBtn(row) ? [_c('i', {
          staticClass: "fa fa-spinner fa-spin"
        }), _c('span', {
          staticClass: "d-inline-block ml-2",
          attrs: {
            "tabindex": "0",
            "data-toggle": "tooltip",
            "title": _vm.tooltipText
          }
        }, [_vm._v(" Loading .. ")])] : _vm.isDownloaded(row) ? [_c('i', {
          staticClass: "fa fa-check"
        }), _c('span', {
          staticClass: "d-inline-block ml-2",
          attrs: {
            "tabindex": "0",
            "data-toggle": "tooltip",
            "title": _vm.tooltipText
          }
        }, [_vm._v(" Processed ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), !row.alloweddownload ? _c('div', [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Vendor Id Issue ")]) : _vm._e()];
      }
    }], null, false, 1451242544)
  })], 1) : !_vm.query_search ? _c('div', [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex",
    staticStyle: {
      "height": "65vh"
    }
  }, [_c('svg', {
    staticClass: "w-16 h-16 text-gray-800 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("Select Filter to Display")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("Your data will be displayed once the filter has been selected.")])])]) : _vm._e(), _vm.query_search && _vm.items.length === 0 ? _c('div', [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex",
    staticStyle: {
      "height": "65vh"
    }
  }, [_c('svg', {
    attrs: {
      "width": "35",
      "height": "35",
      "viewBox": "0 0 64 64",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z",
      "fill": "#4B5563"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z",
      "fill": "#4B5563"
    }
  }), _c('path', {
    attrs: {
      "d": "M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z",
      "fill": "#4B5563"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No results found")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("Change your keyword or filter")])])]) : _vm._e(), !_vm.isLoading && (_vm$items2 = _vm.items) !== null && _vm$items2 !== void 0 && _vm$items2.length ? _c('div', {
    staticClass: "flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }